<template>
  <div class="msg-header d-flex align-items-center py-3 px-3" style="border-bottom: 1px solid #e0e4e8">
    <el-dialog width="60vw" title="Chi tiết công việc" v-if="app.isShowTodoDetail"
               :visible.sync="app.isShowTodoDetail" :destroy-on-close="true">
      <TodoDetail :members="members" :selected-account="{accountId:conversation.accountId}" :todo-item="app.todoItem"
                  @closeDialog="app.isShowTodoDetail = false" />
    </el-dialog>
    <el-dialog v-if="showTagHistoryPopup" top="40px" :visible.sync="showTagHistoryPopup"
               title="Lịch sử gắn tag"
               append-to-body width="800px"
               destroy-on-close>
      <TagHistoryPopup :conversation-id="conversation.id" />
    </el-dialog>
    <el-dialog v-if="showDialog" width="500px" top="40px" :visible.sync="showDialog" title="Thêm thành viên"
               destroy-on-close>
      <AddMember :conversation="idConversationGroup" :members="members" />
    </el-dialog>
    <el-dialog title="Tạo nhóm" :visible.sync="showCreatePopup"
               :close-on-click-modal="false" width="800px" top="40px"
               destroy-on-close @opened="setId()">
      <create-group ref="createGrMsg" :account-id="conversation.accountId" :userId="getUserId()" />
    </el-dialog>
    <el-dialog v-if="showProfileGroup" width="360px" :visible.sync="showProfileGroup" title="Thông tin nhóm"
               :destroy-on-close="true">
      <GroupInfoPopup :members="members.length"
                      :avatar="(avatar != null && avatar !== '')?avatar:'/assets/images/no-avatar.png'" :name="toName"
                      :closeGroupInfoPopup="showProfileGroup"
                      :idConversationGroup="idConversationGroup" />
    </el-dialog>
    <el-dialog :title="'Đặt biệt danh cho :'+conversation.toName" width="500px" v-if="showPopOverSwName"
               :visible.sync="showPopOverSwName" destroy-on-close>
      <div>
        <el-input placeholder="Nhập biệt danh" type="textarea" :rows="3" v-model="conversation.swName"
                  resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button type="primary" size="mini" plain @click="saveSwName()">Lưu</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-if="showProfile" width="360px" top="40px" :visible.sync="showProfile">
      <ProfileInfoPopup :data="data" :conversation="conversation" />
    </el-dialog>

    <div @click="showInfo()" class="pointer">
      <el-badge is-dot class="online-status position-relative" type="success" :hidden="!online">
        <el-avatar :src="(avatar != null && avatar !== '')?avatar:'/assets/images/no-avatar.png'"
                   class="rounded-circle avatar-xs" alt="" />
        <img src="/assets/icon/icon_red_block.svg" v-if="data != null && data.isBlocked === 1"
             class="p-1 position-absolute"
             style="background-color:white; border-radius:9999px; top: 25px;left:-5px;height: 18px;width: 18px;z-index: 999" />
      </el-badge>
    </div>

    <div style="margin-left:.4rem" class="d-flex flex-column">
      <div>
        <span class="fw-semibold font-size-17 pointer"
              @click="showInfo()">{{ conversation.swName && conversation.swName.length > 0 ? conversation.swName : toName
          }}</span>
        <el-tooltip class="item pointer" effect="dark" content="Đặt biệt danh cho liên hệ" slot="reference"
                    placement="top">
          <i class="el-icon-edit-outline font-size-16 fw-bolder mt-1 mx-2" style="color: #0A58C0"
             @click="showPopOver(item)" />
        </el-tooltip>
      </div>
      <span v-if="!members">{{ lastOnlineStr }}</span>
      <span v-else>{{ members.length }} thành viên</span>
    </div>


    <div class="d-flex justify-content-end flex-1">
      <el-tooltip  class="item pointer" effect="dark" content="Ghi chú" slot="reference"
                  placement="top" v-if="idConversationGroup && members != undefined && members.length>0">
        <NoteGroup :key="idConversationGroup.accountId+idConversationGroup.toId"
                   :IdConversationGroup="idConversationGroup" />
      </el-tooltip>
      <div class="m-1"></div>
      <el-tooltip v-if="!conversation.group" effect="dark"
                  :content="'Tạo nhóm với ' + getName">
        <el-image v-if="isFriend()" class=" pointer" @click="showDialogMembers()"
                  src="/assets/icon/add_group.svg" />
      </el-tooltip>
      <el-tooltip v-if="conversation.group && members != undefined && members.length>0" class="item pointer" effect="dark" content="Thêm thành viên vào nhóm" slot="reference"
                  placement="top">
        <el-image class=" pointer" @click="showDialogMembers()"
                  src="/assets/icon/add_group.svg" />
      </el-tooltip>
      <div class="m-1" v-if="conversation.unreadCount==0"></div>
      <el-tooltip class="item pointer" effect="dark" content="Đánh dấu là chưa đọc" slot="reference"
                  placement="top"><i class="icon-mess-new font-size-20 text-secondary "
                                     @click="setRead(conversation.id)" v-if="conversation.unreadCount==0" />
      </el-tooltip>
      <div class="m-1"></div>
      <el-tooltip class="item pointer" effect="dark" content="Ẩn liên hệ" slot="reference"
                  placement="top"><i class="icon-visible font-size-20 text-secondary "
                                     @click="hiddenChange()" />
      </el-tooltip>
      <div class="m-1" v-if="conversation.group && members != undefined && members.length>0"></div>
<!--      <el-tooltip class="item pointer" v-if="conversation.group && members != undefined && members.length>0" effect="dark" content="Làm mới"-->
<!--                  slot="reference"-->
<!--                  placement="top"><i class="font-size-20 el-icon-refresh"-->
<!--                                     @click="syncMessage()" />-->
<!--      </el-tooltip>-->
      <div class="m-1"></div>
      <el-tooltip class="item pointer" effect="dark" content="Lịch sử gắn tag" slot="reference"
                  placement="top">
        <i class="icon-tag-2 font-size-20" @click="showTagHistory()" />
      </el-tooltip>
      <div class="m-1"></div>
      <el-tooltip class="item pointer" effect="dark" :content="pin?'Bỏ ghim hội thoại':'Ghim hội thoại'"
                  slot="reference"
                  placement="top"><i class="font-size-20"
                                     v-bind:class="!pin?'icon-star text-secondary':'icon-star-fill text-warning'"
                                     @click="pinConversation()" />
      </el-tooltip>

      <div class="m-1"></div>

    </div>
    <div class="ms-1" />
    <el-tooltip :visible-arrow="false" class="item pointer" effect="dark" content="Thông tin hội thoại"
                slot="reference" placement="top" v-if="!this.app.switchCRM">
      <i
        class="font-size-20 p-2"
        style="border-radius: 50%;background-color: #DCDFE9  "
        v-bind:class="app.expandMessage?'icon-arrow-left':'icon-arrow-right icon-hover-expand'"
        @click="toggeExpand()" />
    </el-tooltip>

  </div>

</template>

<script>
import NoteGroup from "../NoteGroup";
import AddMember from "../AddMember";
import ProfileInfoPopup from "../ProfileInfoPopup";
import GroupInfoPopup from "../GroupInfoPopup";
import CreateGroup from "../contact/CreateGroup";
import TagHistoryPopup from "../tag/TagHistoryPopup";
import TodoDetail from "../todo/TodoDetail";

export default {
  components: { TodoDetail, TagHistoryPopup, CreateGroup, GroupInfoPopup, ProfileInfoPopup, AddMember, NoteGroup },
  props: ["avatar", "online", "toName", "lastOnlineStr", "idConversationGroup", "members", "conversation", "data", "pin"],
  data() {
    return {
      showProfileGroup: false,
      showDialog: false,
      showProfile: false,
      showPopOverSwName: false,
      dataProfile: {},
      showCreatePopup: false,
      showTagHistoryPopup: false
    };
  },
  computed: {
    getName() {
      if (this.conversation.swName !== null && this.conversation.swName.length > 0) {
        return this.conversation.swName;
      } else {
        return this.toName;
      }
    }
  },
  methods: {
    showTagHistory() {
      this.showTagHistoryPopup = true;
    },
    toggeExpand() {
      let item = localStorage.getItem("expandMessage");

      if (item === "true") {
        localStorage.setItem("expandMessage", false);
        this.app.expandMessage = false;
      } else {
        localStorage.setItem("expandMessage", true);
        this.app.expandMessage = true;
      }

    },
    getUserId() {
      if (!this.data) {
        return null;
      } else {
        return this.data.userId;
      }
    },
    isFriend() {
      try {
        return this.data?.isFr !== 0;
      } catch (e) {
        return true;
      }
    },
    setId() {
      this.$refs.createGrMsg.setAccountId(this.conversation.accountId);
    },
    showDialogMembers() {
      if (this.conversation.group) {
        this.showDialog = true;
      } else {
        this.showCreatePopup = true;
      }
    },
    showPopOver() {
      this.showPopOverSwName = true;
    },
    saveSwName() {
      this.$http.get("/api/conversation/setSwName", {
        params: {
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id,
          swName: this.conversation.swName
        }
      });
      this.showPopOverSwName = false;
    },
    showInfo() {
      if(this.members !== undefined){
        if(this.members.length==0 && this.conversation.group){
        return;
      }
      }

      if (!this.conversation.page && !this.conversation.group) {
        this.showProfile = true;
      }
      if (!this.conversation.page && this.conversation.group) {
        this.showProfileGroup = true;
      }
    },
    closeGroupInfo() {
      this.showProfileGroup = false;
    },
    pinConversation() {
      let request = [];
      if (this.pin) {
        let filter = this.app.pinConversations.filter(m => m.id == this.conversation.id);
        if (filter != null && filter.length > 0) {
          let index = this.app.pinConversations.indexOf(filter[0]);
          if (index > -1) {
            this.app.pinConversations.splice(index, 1);
          }
        }
      } else {
        request.push({
          accountId: this.conversation.accountId,
          conversationId: this.conversation.id
        });
      }
      this.app.pinConversations.forEach((p) => {
        request.push({
          accountId: p.accountId,
          conversationId: p.id
        });
      });
      this.pin = !this.pin;
      this.$http.post("/api/conversation/pin/save", { items: request }).then(() => this.fetchPinConversation());
    },
    syncMessage(conversation) {
      this.$bus.$emit("syncMessageEmit", conversation);
    },
    hiddenChange() {
      this.$confirm("Bạn có chắc chắn muốn ẩn liên hệ này trong phần Danh sách tin nhắn không?", "Xác nhận ẩn liên hệ", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(async () => {
        this.$http.get("/api/conversation/hidden", {
          params: {
            accountId: this.conversation.accountId,
            conversationId: this.conversation.id,
            hidden: true
          }
        });
      });
    }
  },

  mounted() {
    let item = localStorage.getItem("expandMessage");
    if (item === null) {
      localStorage.setItem("expandMessage", "true");
      this.app.expandMessage = true;
    } else {
      this.app.expandMessage = item === "true";
    }

    this.$bus.$on("closeProfile", () => this.showProfile = false);
    this.$bus.$on("closeCreateGrMsg", () => this.showCreatePopup = false);
    this.$bus.$on("closeDialogMember", () => {
        this.showDialog = false;
      }
    );
    this.$bus.$on("closeGroupInfoPopup", () => this.closeGroupInfo());
  },
  beforeDestroy() {
    this.$bus.$off("closeProfile");
    this.$bus.$off("closeGroupInfoPopup");
    this.$bus.$off("closeDialogMember");
    this.$bus.$off("closeCreateGrMsg");

  }
};
</script>

<style scoped>
.icon-hover-expand:hover {
  background-color: #d6d8dd;
}
</style>
